import React from 'react';
import { Trash16, Download16 } from '@honeybook/icons';
import { ThumbnailActions } from '../HBFileThumbnail/HBFileThumbnail.styles';
import { IAttachmentFile } from '../HBFileThumbnail/HBFilesThumbnails';
import HBIconButton from '../HBIconButton/HBIconButton';
import withStopPropagation from '../common/withStopPropagation';
import { isFunction } from 'lodash-es';

interface Props {
    file: IAttachmentFile;
    onDeleteFile: (file: IAttachmentFile) => void;
    onDownloadFile: (file: IAttachmentFile) => void;
    isDeletable: boolean;
    deleteTooltipText?: string;
}

const HBFileThumbnailActions = ({
    onDeleteFile,
    onDownloadFile,
    isDeletable,
    file,
    deleteTooltipText
}: Props) => {
    return (
        <ThumbnailActions hasDeleteButton={isDeletable}>
            <HBIconButton
                buttonTheme="light-invisible"
                icon={Download16}
                label="download"
                onClick={withStopPropagation(
                    () => onDownloadFile && onDownloadFile(file)
                )}
                size="xs"
                testIdName="download"
            />

            {isDeletable && isFunction(onDeleteFile) && (
                <HBIconButton
                    buttonTheme="light-invisible"
                    icon={Trash16}
                    label="delete"
                    onClick={withStopPropagation(() => onDeleteFile(file))}
                    size="xs"
                    disabled={file.isDeleteDisabled}
                    tooltip={deleteTooltipText}
                    testIdName="delete"
                />
            )}
        </ThumbnailActions>
    );
};

export default HBFileThumbnailActions;
